'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgPersonGroup(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M8.288 5.877c.942 0 1.772-.847 1.772-1.952 0-1.099-.83-1.895-1.772-1.895-.937 0-1.767.819-1.767 1.907 0 1.093.83 1.94 1.767 1.94zm-5.058.1c.819 0 1.542-.74 1.542-1.698 0-.96-.723-1.649-1.542-1.649-.813 0-1.542.707-1.542 1.66 0 .947.729 1.688 1.542 1.688zM.819 9.97h3.213c-.449-.746.162-2.08 1.099-2.787a3.467 3.467 0 00-1.901-.532C1.245 6.65 0 8.13 0 9.337c0 .398.219.633.819.633zm4.76 0h5.423c.751 0 .998-.213.998-.6 0-1.138-1.424-2.708-3.712-2.708-2.282 0-3.707 1.57-3.707 2.708 0 .387.247.6.998.6z", id: "Person-group___svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Person-group___svg__a" })))));
}

module.exports = SvgPersonGroup;
//# sourceMappingURL=PersonGroup.js.map
